<template>
  <div class="mt-5">
    <u-loader v-if="isLoading" />
    <div v-else>
      <v-card class="mr-4">
        <div v-if="isEnabled">
          <v-card-title class="bg-light border-bottom">
            <h5>Gesetzlicher Mindestlohn</h5>
          </v-card-title>

          <u-error-handling
            v-if="errorObject"
            class="col-12 mt-4"
            :error-object="errorObject"
          />
          <v-card-text
            v-if="currentStatus"
            class="container pl-0 ml-4"
          >
            <div class="row">
              <div class="col-2">
                Zuletzt geprüft:
              </div>
              <div>
                <span v-if="currentStatus.updated">
                  {{ formatDate(currentStatus.updated) }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                Status:
              </div>
              <div>
                <span v-if="currentStatus.state">
                  {{ validationStates[currentStatus.state] }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                Prognose:
              </div>
              <div>
                <span v-if="currentStatus.prediction">
                  {{ predictions[currentStatus.prediction] }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                Prognose für:
              </div>
              <div>
                <span v-if="currentStatus.predictionForYear">
                  {{ currentStatus.predictionForYear }}
                </span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <div class="ml-2">
              <b-button
                variant="success"
                :disabled="checkStarted"
                @click="startValidation()"
              >
                <div v-if="checkStarted">
                  Prüfung läuft
                </div>
                <div v-else>
                  Prüfung starten
                </div>
              </b-button>
            </div>
          </v-card-actions>
        </div>
        <div v-else>
          <v-alert
            :value="true"
            type="info"
          >
            Gesetzliche Mindestlohnprüfung ist deaktiviert für diese
            Konfiguration.
          </v-alert>
        </div>
      </v-card>

      <v-card
        v-if="isEnabled"
        class="mt-5 mr-4"
      >
        <v-expansion-panel>
          <v-expansion-panel-content>
            <template v-slot:header>
              <v-card-title class="bg-light border-bottom">
                <h5>Ausnahmeregeln</h5>
              </v-card-title>
            </template>
            <v-card>
              <legal-minimum-wage-exclusions :configuration-id="configId" />
            </v-card>
          </v-expansion-panel-content>

          <u-loader v-if="isLoadingResults" />

          <v-expansion-panel-content
            v-if="validationErrors && validationErrors.length > 0"
          >
            <template v-slot:header>
              <v-card-title class="bg-light border-bottom">
                <h5>Verstösse (Total: {{ validationErrors.length }})</h5>
              </v-card-title>
            </template>
            <v-card>
              <legal-minimum-wage-validation-result-table
                :results="validationErrors"
              />
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content
            v-if="validationWarnings && validationWarnings.length > 0"
          >
            <template v-slot:header>
              <v-card-title class="bg-light border-bottom">
                <h5>Warnungen (Total: {{ validationWarnings.length }})</h5>
              </v-card-title>
            </template>
            <v-card>
              <legal-minimum-wage-validation-result-table
                :results="validationWarnings"
              />
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </div>
  </div>
</template>

<script>
import {
  GetCantonalMinimumWageValidationResults,
  GetCantonalMinimumWageValidationState,
  StartCantonalMinimumWageValidation,
  GetMinimalsalaryvalidationstates,
  GetMinimalsalarypredictionstates,
} from "@/services/minimum.wage.services/canton.minimum.wages.js";
import LegalMinimumWageValidationResultTable from "./LegalMinimumWageValidationResultTable.vue";
import LegalMinimumWageExclusions from "./LegalMinimumWageExclusions.vue";

export default {
  components: {
    LegalMinimumWageValidationResultTable,
    LegalMinimumWageExclusions,
  },
  props: {
    configId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingResults: false,
      currentStatus: null,
      errorObject: null,
      validationErrors: [],
      validationWarnings: [],
      validationStates: [],
      predictions: [],
      checkStarted: false,
    };
  },
  computed: {
    isEnabled() {
      return this.$store.state.mindestLohnKonfiguration.Configuration
        .gesetzlicherMindestlohnCheckEnabled;
    },
  },
  watch: {
    currentStatus(val) {
      if (val && val.state == 4) {
        if (!this.resultsLoaded) {
          this.loadResults();
        }
      }
    },
  },
  created() {
    this.loadStatus(false);
    this.loadResults();
    this.loadMinimalsalaryvalidationstates();
    this.loadMinimalsalarypredictionstates();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  methods: {
    startValidation() {
      this.checkStarted = true;
      let that = this;

      StartCantonalMinimumWageValidation(
        this.configId,
        () => {
          that.loadStatus(true);
        },
        (error) => {
          that.errorObject = error;
        },
      );
    },
    loadStatus(background) {
      if (!background) this.isLoading = true;

      let that = this;
      GetCantonalMinimumWageValidationState(
        this.configId,
        (response) => {
          that.currentStatus = response;
          if (!background) that.isLoading = false;
        },
        (error) => {
          console.error("error", error);
          that.currentStatus = undefined;
          that.errorObject = error;
          that.isLoading = false;
        },
      );
    },
    formatDate(date) {
      var newDate = this.$moment(date).format("DD.MM.YYYY HH:mm");
      return newDate;
    },
    loadResults() {
      this.isLoadingResults = true;
      GetCantonalMinimumWageValidationResults(
        this.configId,
        (response) => {
          this.validationErrors = response.filter(
            (x) => x.result === 1 || x.result === 2,
          );
          this.validationWarnings = response.filter(
            (x) => x.result === 3 || x.result === 4,
          );
          this.isLoadingResults = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoadingResults = false;
        },
      );
    },
    getStundenlohnPlus13(calcResult) {
      return (
        calcResult.basisstundenlohn + calcResult.entschaedigung13Monatslohn
      );
    },
    getMinimalSalaryValidationState(state) {
      if (state && this.validationStates) {
        return this.validationStates[state];
      } else {
        return "-";
      }
    },
    getMinimalSalaryPredictionState(state) {
      if (state && this.predictions) {
        return this.predictions[state];
      } else {
        return "-";
      }
    },

    loadMinimalsalaryvalidationstates() {
      GetMinimalsalaryvalidationstates(
        (response) => {
          this.validationStates = response;
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadMinimalsalarypredictionstates() {
      GetMinimalsalarypredictionstates(
        (response) => {
          this.predictions = response;
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  font-size: 17px;
  padding: 0px;
}
</style>
